  import React from 'react';
  import Logo from '../logo_maxi.png';
  import { ListGroupItem, Row, Col, Input } from 'reactstrap';

  export default class Loader extends React.Component {
    constructor (props) {
      super(props);

      this.state = {
        error : '',
      };

    }

    componentDidMount(){
    }



    render () {


      return (
        <React.Fragment>
        <div style={{position:"fixed", top:"0", left:"0", width: "100%", height:"100%", zIndex:"10"}} >
          <div>
            <img id="Spinner" src="/assets/branding/boucheTiChanteur.png" width="100%"  alt="Liste vide!" style={{
              maxWidth:"50px"
            }} />
          <img src="/assets/branding/tiChanteur.png"
            width="100%"
            alt="Liste vide!"
            style={{  marginTop:"190px",
                      maxWidth:"200px" }}/>
            <h4 style={{
              fontWeight:"bold",
              textTransform:"uppercase",
              maxWidth:"413px",
              margin:"auto"
            }}>Chargement de votre liste d’épicerie chantée en cours...</h4>

           </div>
        </div>
        </React.Fragment>
      );
    }
  }
